/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */

"use strict";
(function(global) {
    class InputElement extends HTMLDivElement {
        static lastId = 1;

        constructor(inputName: string, label: string, ...args) {
            super(...args);

            this.inputName = inputName;
            this.label = label;
            this.inputId = `custom_input_element_cool_id_${InputElement.lastId++}`;
            this.input = document.createElement('input');
            this.inputType = 'text';
        }

        connectedCallback(): void {
            this.classList.add('form-group', 'fg-float', 'm-b-5');

            const inputDivElement = document.createElement('div');
            inputDivElement.classList.add('fg-line');

            inputDivElement.appendChild(this.input);
            this.input.setAttribute('name', this.inputName);
            this.input.setAttribute('id', this.inputId);
            this.input.setAttribute('type', this.inputType);
            this.input.classList.add('input-sm', 'form-control', 'fg-input');
            this.appendChild(inputDivElement);

            if (this.label !== null) {
                const label = document.createElement('label');
                label.setAttribute('for', this.inputId);
                label.classList.add('fg-label');
                label.innerText = this.label;

                this.appendChild(label);
            }
        }

        get value(): string {
            return this.input.value;
        }

        set value(v: string) {
            this.input.value = v;
        }

        set type(type: string) {
            this.inputType = type;
            this.input.type = type;
        }
    }

    class CheckboxElement extends HTMLDivElement {
        static lastId = 1;

        constructor(inputName: string, label: string, ...args) {
            super(...args);

            this.inputName = inputName;
            this.label = label;
            this.inputId = `custom_input_element_cool_id_${CheckboxElement.lastId++}`;
            this.input = document.createElement('input');
        }

        connectedCallback(): void {
            this.classList.add('form-group', 'fg-float', 'm-b-5');

            const checkboxContainer = document.createElement('div');
            checkboxContainer.classList.add('col-sm-12', 'checkbox-field-container');
            const checkboxElement = document.createElement('div');
            checkboxElement.classList.add('checkbox');
            const labelElement = document.createElement('label');

            checkboxContainer.appendChild(checkboxElement);
            checkboxElement.appendChild(labelElement);
            labelElement.appendChild(this.input);
            this.input.setAttribute('name', this.inputName);
            this.input.setAttribute('id', this.inputId);
            this.input.setAttribute('type', 'checkbox');
            this.input.classList.add('checkbox', 'style-0');
            const inputHelper = document.createElement('i');
            inputHelper.classList.add('input-helper');
            labelElement.appendChild(inputHelper);
            this.appendChild(checkboxContainer);

            if (this.label !== null) {
                labelElement.appendChild(document.createTextNode(this.label));
            }
        }

        get value(): string {
            return this.input.value;
        }

        set value(v: string) {
            this.input.value = v;
        }
    }

    class DeleteRowButtonElement extends HTMLDivElement {
        constructor(elementToRemove: HTMLElement, ...args) {
            super(...args);

            this.victim = elementToRemove;
        }

        connectedCallback(): void {
            this.classList.add('col-md-1');

            const button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.classList.add('btn');
            button.classList.add('btn-default');
            button.innerText = 'Usuń';
            this.appendChild(button);

            this.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                if (this.victim) {
                    this.victim.remove();
                    delete this.victim;
                }
            });
        }
    }

    class DdosNotificationEmailElement extends HTMLDivElement {
        connectedCallback() {
            const li = document.createElement('li');
            li.classList.add('row', 'm-b-20');
            this.appendChild(li);

            const liDiv = document.createElement('div');
            liDiv.classList.add('col-md-11');
            li.appendChild(liDiv);

            liDiv.appendChild(new InputElement('companyServicesType[ddosNotificationEmails][][email]', 'Adres email'));
            li.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class ManagedObject {
        id: number;
        label: string;
        companyName: string | null;
        selected: boolean;
        children: (ManagedObject | null)[];

        constructor(id: number, label: string, companyName: string | null, selected: boolean, children: (ManagedObject | null)[] = []) {
            this.id = id;
            this.label = label;
            this.companyName = companyName;
            this.selected = selected;
            this.children = children;
        }
    }

    class DDoSContainer {
        constructor() {
            this.element = document.getElementById('mo-container');
            this.ul = undefined;
        }

        clear() {
            while (this.element.lastChild) {
                this.element.removeChild(this.element.lastChild);
            }

            delete this.ul;
        }

        append(mo: ManagedObject) {
            if (!this.ul) {
                this.ul = document.createElement('ul');
                this.ul.classList.add('checkbox-tree');

                this.element.appendChild(this.ul);
            }

            const li = this._li(mo);
            const ul = document.createElement('ul');

            for (const child of mo.children) {
                ul.appendChild(this._li(child));
            }

            this.ul.appendChild(li);
            li.appendChild(ul);
        }

        message(msg: string) {
            const p = document.createElement('p');
            p.style.textAlign = 'center';
            p.innerText = msg;

            this.clear();
            this.element.appendChild(p);
        }

        // noinspection JSMethodCanBeStatic
        _li(mo: ManagedObject) {
            const div = document.createElement('div');
            div.classList.add('checkbox');

            const li = document.createElement('li');
            // noinspection JSUndefinedPropertyAssignment
            li.managedObject = mo;
            li.appendChild(div);

            const label = document.createElement('label');
            div.appendChild(label);

            const input = document.createElement('input');
            input.setAttribute('type', 'checkbox');
            input.classList.add('checkbox', 'style-0');
            input.setAttribute('value', `${mo.id}`);
            input.setAttribute('name', 'companyServicesType[managedObjects][]');
            label.appendChild(input);

            if (mo.selected) {
                input.setAttribute('checked', 'checked');
            }

            const i = document.createElement('i');
            i.classList.add('input-helper');
            label.appendChild(i);

            const txt = document.createTextNode(`${mo.label} (${mo.companyName || 'n.a.'})`);
            label.appendChild(txt);

            return li;
        }
    }

    class DDoS {
        constructor(companyId: number, loadUrl: string) {
            this.container = new DDoSContainer();
            this.companyId = companyId;
            this.loadUrl = loadUrl;
            this.managedObjects = [];

            this.mo = new rxjs.Subject();
            this.mo$ = this.mo.asObservable().pipe(rxjs.operators.map(data => {
                const results = [];

                for (const row of data) {
                    const children = [];

                    for (const child of row.children || []) {
                        children.push(new ManagedObject(child.id, child.label, child.companyName, child.selected));
                    }

                    results.push(new ManagedObject(row.id, row.label, row.companyName, row.selected, children));
                }

                return results;
            }), rxjs.operators.tap(data => this.managedObjects = data));
            this.mo$.subscribe(this.draw.bind(this));

            this.container.message('Wczytywanie danych...');
            this.loadManagedObjects();

            this.bindEvents();
        }

        loadManagedObjects() {
            // noinspection JSUnusedLocalSymbols
            ApiConnect.get(this.loadUrl).then(data => {
                this.mo.next(data);
            }).catch((errorThrown) => {
                this.mo.error(errorThrown.toString());
                this.container.message('Wystąpił błąd podczas wczytywania danych.')
            });
        }

        draw(data) {
            this.container.clear();

            if (!(data || []).length) {
                this.container.message('Brak danych do wyświetlenia.');
                return;
            }

            for (const mo of data) {
                this.container.append(mo);
            }

            ApiCheckboxTree.init();
        }

        bindEvents() {
            document.getElementById('addDdosNotificationEmailID').addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('ddosNotificationEmailsList');
                list.appendChild(new DdosNotificationEmailElement());
            });
        }
    }

    class VlanIdentifierElement extends HTMLLIElement {
        connectedCallback(): void {
            this.classList.add('row', 'm-b-20');

            const div = document.createElement('div');
            div.classList.add('col-md-11');
            div.appendChild(new InputElement('companyServicesType[vlans][][name]', 'Identyfikator vlan'));

            this.appendChild(div);
            this.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class MalwareFirewallElement extends HTMLLIElement {
        static lastId: number = 1000;

        connectedCallback(): void {
            this.classList.add('row', 'm-b-20');

            const liDivOuter = document.createElement('div');
            liDivOuter.classList.add('col-md-11');

            const liDivInner = document.createElement('div');
            liDivInner.classList.add('row');
            liDivOuter.appendChild(liDivInner);

            const inputs = [
                { name: `companyServicesType[firewalls][${this.id}][ip]`, label: 'IP firewalla' },
                { name: `companyServicesType[firewalls][${this.id}][name]`, label: 'Nazwa firewalla' },
                { name: `companyServicesType[firewalls][${this.id}][deviceId]`, label: 'Identyfikator device id' }
            ];

            for (const data of inputs) {
                const inputContainer = document.createElement('div');
                inputContainer.classList.add('col-md-4');
                inputContainer.appendChild(new InputElement(data.name, data.label));
                liDivInner.appendChild(inputContainer);
            }

            this.appendChild(liDivOuter);
            this.appendChild(new DeleteRowButtonElement(this));
        }

        get id(): number {
            return this._id || (this._id = MalwareFirewallElement.lastId++);
        }
    }

    class MalwareProtection {
        constructor() {
            this.addVlanButton = document.getElementById('addVlanID');
            this.addDeviceButton = document.getElementById('addFirewall');

            this.bindEvents();
        }

        bindEvents(): void {
            this.addVlanButton.addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('vLanList');
                list.appendChild(new VlanIdentifierElement());
            });

            this.addDeviceButton.addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('firewallsList');
                list.appendChild(new MalwareFirewallElement());
            });
        }
    }

    class WebApplicationInputElement extends HTMLLIElement {
        constructor(inputName: string, label: string, ...args) {
            super(...args);

            this.inputName = inputName;
            this.label = label;
        }

        connectedCallback() {
            this.classList.add('row', 'm-b-20');

            const div = document.createElement('div');
            div.classList.add('col-md-11');
            div.appendChild(new InputElement(this.inputName, this.label));

            this.appendChild(div);
            this.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class WebApplicationProtection {
        constructor() {
            const actions = [
                { buttonId: 'addTunnelID', listId: 'tunnelList', inputName: 'companyServicesType[tunnels][][name]', label: 'Identyfikator tunelu' },
                { buttonId: 'addNetworkPolicyName', listId: 'networkPolicyList', inputName: 'companyServicesType[networkPolicies][][name]', label: 'Nazwa polityki' },
                { buttonId: 'addServerPolicyName', listId: 'serverPolicyList', inputName: 'companyServicesType[serverPolicies][][name]', label: 'Nazwa polityki' }
            ];

            for (const action of actions) {
                document.getElementById(action.buttonId).addEventListener('click', e => {
                    e.preventDefault();

                    const list = document.getElementById(action.listId);
                    list.appendChild(new WebApplicationInputElement(action.inputName, action.label));
                });
            }
        }
    }

    class CyberPakietNotificationEmailElement extends HTMLDivElement {
        connectedCallback() {
            const li = document.createElement('li');
            li.classList.add('row', 'm-b-20');
            this.appendChild(li);

            const liDiv = document.createElement('div');
            liDiv.classList.add('col-md-11');
            li.appendChild(liDiv);

            liDiv.appendChild(new InputElement('companyServicesType[cyberPakietNotificationEmails][][email]', 'Adres email'));
            li.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class CyberPakietInputElement extends HTMLLIElement {
        constructor(inputName: string, label: string, ...args) {
            super(...args);

            this.inputName = inputName;
            this.label = label;
        }

        connectedCallback() {
            this.classList.add('row', 'm-b-20');

            const div = document.createElement('div');
            div.classList.add('col-md-11');
            div.appendChild(new InputElement(this.inputName, this.label));

            this.appendChild(div);
            this.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class CyberPakietNetworkTestConfigurationItemElement extends HTMLLIElement {
        static lastId: number;

        connectedCallback(): void {
            this.classList.add('row', 'm-b-20');

            const liDivOuter = document.createElement('div');
            liDivOuter.classList.add('col-md-11');

            const liDivInner = document.createElement('div');
            liDivInner.classList.add('row', 'm-t-30');
            liDivOuter.appendChild(liDivInner);

            const inputs = [
                { name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][ipAddress]`, label: 'Adres IP', widthClass: 'col-md-3', labelUpClass: 'label-up' },
                { name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][hostname]`, label: 'Hostname', widthClass: 'col-md-3', labelUpClass: 'label-up' },
                { name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][routingDomain]`, label: 'Domena routingowa', type: 'text', widthClass: 'col-md-1', labelUpClass: 'label-up-25' },
                { name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][daysInterval]`, label: 'Interwał w dniach', type: 'number', widthClass: 'col-md-1', labelUpClass: 'label-up-25' },
                { name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][orderHour]`, label: 'Godz. zlecenia (0-23)', type: 'number', widthClass: 'col-md-1', labelUpClass: 'label-up-40' },
				{ name: `companyServicesType[cyberPakietNetworkTestConfiguration][${this.id}][forceOnNextRequest]`, label: 'Wymuś przy kolejnym żądaniu', type: 'checkbox', widthClass: 'col-md-3' }
            ];

            for (const data of inputs) {
                const inputContainer = document.createElement('div');
                inputContainer.classList.add(data.widthClass);
                let inputElement;

				if (data.type === 'checkbox') {
					inputElement = new CheckboxElement(data.name, data.label);
				} else {
					inputElement = new InputElement(data.name, data.label);

					if (typeof data.type !== 'undefined') {
						inputElement.type = data.type;
					}
				}

				if (typeof data.labelUpClass !== 'undefined') {
                    inputElement.classList.add(data.labelUpClass);
                }

                inputContainer.appendChild(inputElement);
                liDivInner.appendChild(inputContainer);
            }

            this.appendChild(liDivOuter);
            const deleteRowButtonElement = new DeleteRowButtonElement(this);
            deleteRowButtonElement.classList.add('m-t-20');
            this.appendChild(deleteRowButtonElement);
        }

        get id(): number {
            return this._id || (this._id = CyberPakietNetworkTestConfigurationItemElement.lastId++);
        }
    }

    class CyberPakietWebAppTestConfigurationItemElement extends HTMLLIElement {
        static lastId: number;

        connectedCallback(): void {
            this.classList.add('row', 'm-b-20');

            const liDivOuter = document.createElement('div');
            liDivOuter.classList.add('col-md-11');

            const liDivInner = document.createElement('div');
            liDivInner.classList.add('row', 'm-t-30');
            liDivOuter.appendChild(liDivInner);

            const id = this.id;
            const inputs = [
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][url]`, label: 'URL', widthClass: 'col-md-2', labelUpClass: 'label-up' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][username]`, label: 'Nazwa użytkownika', widthClass: 'col-md-2', labelUpClass: 'label-up' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][password]`, label: 'Hasło', widthClass: 'col-md-2', labelUpClass: 'label-up' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][routingDomain]`, label: 'Domena routingowa', type: 'text', widthClass: 'col-md-1', labelUpClass: 'label-up-25' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][daysInterval]`, label: 'Interwał w dniach', widthClass: 'col-md-1', type: 'number', labelUpClass: 'label-up-25' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][orderHour]`, label: 'Godz. zlecenia (0-23)', widthClass: 'col-md-1', type: 'number', labelUpClass: 'label-up-40' },
                { name: `companyServicesType[cyberPakietWebAppTestConfiguration][${id}][forceOnNextRequest]`, label: 'Wymuś przy kolejnym żądaniu', widthClass: 'col-md-3', type: 'checkbox' },
            ];

            for (const data of inputs) {
                const inputContainer = document.createElement('div');
                inputContainer.classList.add(data.widthClass);
                let inputElement;

				if (data.type === 'checkbox') {
					inputElement = new CheckboxElement(data.name, data.label);
				} else {
					inputElement = new InputElement(data.name, data.label);

					if (typeof data.type !== 'undefined') {
						inputElement.type = data.type;
					}
				}

				if (typeof data.labelUpClass !== 'undefined') {
                    inputElement.classList.add(data.labelUpClass);
                }

                inputContainer.appendChild(inputElement);
                liDivInner.appendChild(inputContainer);
            }

            this.appendChild(liDivOuter);
            const deleteRowButtonElement = new DeleteRowButtonElement(this);
            deleteRowButtonElement.classList.add('m-t-20');
            this.appendChild(deleteRowButtonElement);
        }

        get id(): number {
            return this._id || (this._id = CyberPakietWebAppTestConfigurationItemElement.lastId++);
        }
    }

    class CyberPakiet {
        constructor() {
            const actions = [
                { buttonId: 'addCyberPakietIpAddress', listId: 'cyberPakietIpAddressList', inputName: 'companyServicesType[cyberPakietIpAddresses][][ipAddress]', label: null },
                { buttonId: 'addCyberPakietIpRange', listId: 'cyberPakietIpRangeList', inputName: 'companyServicesType[cyberPakietIpRanges][][ipRange]', label: null },
                { buttonId: 'addCyberPakietDomainName', listId: 'cyberPakietDomainNameList', inputName: 'companyServicesType[cyberPakietDomainNames][][fqdn]', label: null },
                { buttonId: 'addCyberPakietKeyword', listId: 'cyberPakietKeywordList', inputName: 'companyServicesType[cyberPakietKeywords][][keyword]', label: null },
                { buttonId: 'addCyberPakietId', listId: 'cyberPakietIdList', inputName: 'companyServicesType[cyberPakietIds][][identifier]', label: null },
                { buttonId: 'addCyberPakietEmailDomain', listId: 'cyberPakietEmailDomainsList', inputName: 'companyServicesType[cyberPakietEmailDomains][][domain]', label: null }
            ];

            for (const action of actions) {
                document.getElementById(action.buttonId).addEventListener('click', e => {
                    e.preventDefault();

                    const list = document.getElementById(action.listId);
                    list.appendChild(new CyberPakietInputElement(action.inputName, action.label));
                });
            }

            this.addNetworkTestConfigurationItemButton = document.getElementById('addCyberPakietNetworkTestConfigurationItem');
            this.addWebAppTestConfigurationItemButton = document.getElementById('addCyberPakietWebAppTestConfigurationItem');

            this.bindEvents();
        }

        bindEvents(): void {
            this.addNetworkTestConfigurationItemButton.addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('cyberPakietNetworkTestConfigurationList');

                if (typeof CyberPakietNetworkTestConfigurationItemElement.lastId === 'undefined') {
                    CyberPakietNetworkTestConfigurationItemElement.lastId = list.childElementCount;
                }

                list.appendChild(new CyberPakietNetworkTestConfigurationItemElement());
            });

            this.addWebAppTestConfigurationItemButton.addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('cyberPakietWebAppTestConfigurationList');

                if (typeof CyberPakietWebAppTestConfigurationItemElement.lastId === 'undefined') {
                    CyberPakietWebAppTestConfigurationItemElement.lastId = list.childElementCount;
                }

                list.appendChild(new CyberPakietWebAppTestConfigurationItemElement());
            });

            document.getElementById('addCyberPakietNotificationEmailID').addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('cyberPakietNotificationEmailsList');
                list.appendChild(new CyberPakietNotificationEmailElement());
            });
        }
    }

    class IpQueryElement extends HTMLLIElement {
        static lastId = 1000;

        connectedCallback() {
            this.classList.add('row', 'm-b-20');

            const outerDivElement = document.createElement('div');
            outerDivElement.classList.add('col-md-11');

            const innerDivElement = document.createElement('div');
            innerDivElement.classList.add('row');

            const id = IpQueryElement.lastId++;

            const inputs = [
                { name: `companyServicesType[ipQueryLimits][${id}][queryingIp]`, label: 'Adres IP'},
                { name: `companyServicesType[ipQueryLimits][${id}][dailyQueriesLimit]`, label: 'Dzienny limit zapytań' }
            ];

            for (const data of inputs) {
                const div = document.createElement('div');
                div.classList.add('col-md-4');
                div.appendChild(new InputElement(data.name, data.label));

                innerDivElement.appendChild(div);
            }

            outerDivElement.appendChild(innerDivElement);
            this.appendChild(outerDivElement);
            this.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class ApplicationVersionElement extends HTMLDivElement {
        constructor(appId: number, version: string, ...args) {
            super(...args);

            this.appId = appId;
            this.version = version;
        }

        connectedCallback() {
            this.classList.add('row');
            this.style.marginBottom = '15px';

            const inputElement = new InputElement(`companyServicesType[applications][${this.appId}][versions][][name]`, '');
            inputElement.value = this.version;

            const inputContainerElement = document.createElement('div');
            inputContainerElement.classList.add('col-md-8');
            inputContainerElement.appendChild(inputElement);

            this.appendChild(inputContainerElement);
            this.appendChild(new DeleteRowButtonElement(this));
        }
    }

    class ApplicationVersionsContainerElement extends HTMLDivElement {
        constructor(appId: number, versions: string[], ...args) {
            super(...args);

            this.appId = appId;
            this.versions = versions;
        }

        connectedCallback() {
            this.style.padding = '15px';

            const containerElement = document.createElement('div');
            containerElement.classList.add('row');

            const labelContainerElement = document.createElement('div');
            labelContainerElement.classList.add('col-md-2');
            labelContainerElement.style.lineHeight = '37px';
            labelContainerElement.innerText = 'Wersja aplikacji';

            const versionsContainerElement = document.createElement('div');
            versionsContainerElement.classList.add('col-md-10');

            this.appendChild(containerElement);
            containerElement.appendChild(labelContainerElement);
            containerElement.appendChild(versionsContainerElement);

            const addVersionButton = document.createElement('button');
            addVersionButton.classList.add('btn', 'btn-primary');
            addVersionButton.innerText = 'Dodaj wersję aplikacji';
            addVersionButton.addEventListener('click', e => {
                e.preventDefault();

                versionsContainerElement.removeChild(addVersionButton);
                versionsContainerElement.appendChild(new ApplicationVersionElement(this.appId, ''));
                versionsContainerElement.appendChild(addVersionButton);
            });

            for (const version of this.versions) {
                versionsContainerElement.appendChild(new ApplicationVersionElement(this.appId, version));
            }

            versionsContainerElement.appendChild(addVersionButton);
        }
    }

    class ApplicationElement extends HTMLDivElement {
        static lastId = 0;

        constructor(app?: any, ...args) {
            super(...args);

            this.name = (app || {}).name || '';
            this.versions = (app || {}).versions || [];
            this.appId = ApplicationElement.lastId++;
        }

        connectedCallback() {
            this.style.border = '1px solid gray';
            this.style.borderRadius = '3px';
            this.style.overflow = 'hidden';
            this.style.marginBottom = '15px';

            const nameContainerElement = document.createElement('div');
            nameContainerElement.classList.add('row');
            nameContainerElement.style.backgroundColor = '#fafafa';
            nameContainerElement.style.padding = '15px';
            nameContainerElement.style.borderBottom = '1px solid gray';

            const nameLabelContainerElement = document.createElement('div');
            nameLabelContainerElement.classList.add('col-md-2');
            nameLabelContainerElement.style.lineHeight = '37px';
            nameLabelContainerElement.innerText = 'Nazwa aplikacji';

            const inputElement = new InputElement(`companyServicesType[applications][${this.appId}][name]`, '');
            inputElement.value = this.name;

            const nameInputContainerElement = document.createElement('div');
            nameInputContainerElement.classList.add('col-md-8');
            nameInputContainerElement.appendChild(inputElement);
            nameContainerElement.appendChild(nameLabelContainerElement);
            nameContainerElement.appendChild(nameInputContainerElement);
            nameContainerElement.appendChild(new DeleteRowButtonElement(this));

            this.appendChild(nameContainerElement);
            this.appendChild(new ApplicationVersionsContainerElement(this.appId, this.versions));
        }
    }

    class CompanyServicesSettingsController {
        constructor(options: any) {
            this.companyId = options.companyId;
            this.ddosProtection = new DDoS(this.companyId, options.ddos.loadUrl);
            this.malwareProtection = new MalwareProtection();
            this.webApplicationProtection = new WebApplicationProtection();
            this.cyberPakiet = new CyberPakiet();

            const deleteButtons = document.querySelectorAll('.delete-row');

            for (const button of Array.from(deleteButtons)) {
                button.addEventListener('click', e => {
                    e.preventDefault();

                    button.closest('li').remove();
                });
            }

            // Security Reputation Service
            document.getElementById('addIpQueryLimit').addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('ipQueryLimitsList');
                list.appendChild(new IpQueryElement());
            });

            // Security Code Security Audit
            document.getElementById('addNewApplication').addEventListener('click', e => {
                e.preventDefault();

                const list = document.getElementById('applicationList');
                list.appendChild(new ApplicationElement({}));
            });

            const applications = options.sourceCodeSecurityAudit.applications.map(app => {
                app.versions = (app.versions || []).map(version => version.name);
                return app;
            });

            const list = document.getElementById('applicationList');

            for (const app of applications) {
                list.appendChild(new ApplicationElement(app));
            }
        }
    }

    //rejestracja customElements
    customElements.define('ddos-notification-email', DdosNotificationEmailElement, {extends: 'div'});
    customElements.define('cyber-pakiet-notification-email', CyberPakietNotificationEmailElement, {extends: 'div'});
    customElements.define('delete-row-button', DeleteRowButtonElement, {extends: 'div'});
    customElements.define('form-input', InputElement, {extends: 'div'});
    customElements.define('form-input-checkbox', CheckboxElement, {extends: 'div'});
    customElements.define('vlan-identifier', VlanIdentifierElement, {extends: 'li'});
    customElements.define('malware-firewall', MalwareFirewallElement, {extends: 'li'});
    customElements.define('web-app-input', WebApplicationInputElement, {extends: 'li'});
    customElements.define('cyber-pakiet-input', CyberPakietInputElement, {extends: 'li'});
    customElements.define('cyber-pakiet-network-test-config-item-input', CyberPakietNetworkTestConfigurationItemElement, {extends: 'li'});
    customElements.define('cyber-pakiet-web-app-test-config-item-input', CyberPakietWebAppTestConfigurationItemElement, {extends: 'li'});
    customElements.define('ip-query', IpQueryElement, {extends: 'li'});
    customElements.define('app-element', ApplicationElement, {extends: 'div'});
    customElements.define('app-versions-container', ApplicationVersionsContainerElement, {extends: 'div'});
    customElements.define('app-version', ApplicationVersionElement, {extends: 'div'});

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.CompanyServicesSettings = CompanyServicesSettingsController || {};
})(window);
